import Cookies from 'js-cookie'
import { Message } from 'element-ui'

const TokenKey = 'vue_admin_template_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 会话过期统一出口(多请求并发失败只提示跳转一次):清token→中文提示→回登录页
let sessionExpiredHandled = false
export function handleSessionExpired() {
  if (sessionExpiredHandled) return
  sessionExpiredHandled = true
  removeToken()
  Message({
    message: '登录已过期，请重新登录',
    type: 'warning',
    duration: 2000
  })
  setTimeout(() => {
    window.location.href = window.location.origin + '/#/login'
    window.location.reload()
  }, 800)
}
